import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormGroupDirective,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { FormField } from '@app/shared/models/field.interface';

@Component({
  selector: 'vfs-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextAreaComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class TextAreaComponent implements ControlValueAccessor {
  @Input() field: FormField;
  @Input() width = '220px';
  @Input() readonly: boolean;
  // FIXME: Max length not required by default
  @Input() maxLength = 255;
  @Input() error: string;
  @Input() autofocus = false;

  // TextArea
  @Input() minRows = 1;
  @Input() maxRows = 4;

  // No Form
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() hint?: string;
  @Input() formControl: FormControl;
  @Input() required: boolean;

  @Input() disabledInput: boolean;

  @Output() contentChange = new EventEmitter();

  // Textarea
  @ViewChild('textarea') elementTexArea: ElementRef;

  disabled: boolean;
  value: any;
  viewPassword = false;

  scrollToBottom(): void {
    try {
      this.elementTexArea.nativeElement.scrollTop = this.elementTexArea.nativeElement.scrollHeight;
    } catch (err) {}
  }

  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
